  const models = [
  {
    image: require("assets/images/jac/js8pro.jpg"),
    title: "JS8PRO",
    link: "JS8PRO",
  },
  {
    image: require("assets/images/jac/js4.jpg"),
    title: "JS4",
    link: "JS4",
  },
  {
    image: require("assets/images/jac/s2fl.jpg"),
    title: "S2FL",
    link: "S2FL",
  },
  {
    image: require("assets/images/jac/x200.jpg"),
    title: "X200",
    link: "X200",
  },
  {
    image: require("assets/images/jac/t8.jpg"),
    title: "T8",
    link: "T8",
  },
];

export default models;
